import Component from '@glimmer/component';

export default class InitiativesDocumentVersionsSlideoverVersionItemComponent extends Component {
  get isActive() {
    return (
      this.args?.selectedVersion &&
      this?.args?.selectedVersion?.id === this?.args?.version?.id
    );
  }
}
